// Invert — negates all color channels. Alpha untouched.
// Each channel becomes 255 - value.

import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export const Invert: Filter<void> = {
  id: "invert",
  displayName: "Invert",
  defaultParams: undefined,

  apply(input: PixelBuffer, _params: void, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const src = input.data;
    const dst = out.data;
    const n = w * h;
    for (let i = 0; i < n; i++) {
      const o = i * 4;
      dst[o] = 255 - (src[o] ?? 0);
      dst[o + 1] = 255 - (src[o + 1] ?? 0);
      dst[o + 2] = 255 - (src[o + 2] ?? 0);
      dst[o + 3] = src[o + 3] ?? 0;
    }
    return out;
  },
};
